import React from "react";
import { useBuyerTestimonials } from "@/lib/useBuyerTestimonials";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const testimonialPhoto = (t) => (t.photo_url ? `${BACKEND}${t.photo_url}` : null);

export const TESTIMONIAL_DISCLAIMER = "Reviews reflect individual client experiences. Not a guarantee of specific outcomes.";
const initials = (name) => name.split(/\s+/).filter(Boolean).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
const AVATAR = {
  display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  fontWeight: 800, fontSize: 14, background: "rgba(241,182,44,0.18)", color: "#f1b62c",
};

const ClassicCard = ({ t }) => (
  <figure className="lp-testimonial" data-testid={`lp-testimonial-${t.id}`}>
    <div className="lp-stars" aria-label={`${t.stars} star review`}>{"★".repeat(t.stars)}</div>
    <blockquote className="lp-quote">&ldquo;{t.quote}&rdquo;</blockquote>
    <figcaption className="lp-testimonial-meta">
      {testimonialPhoto(t)
        ? <img src={testimonialPhoto(t)} alt="" loading="lazy" className="lp-testimonial-photo" style={{ objectFit: "cover" }} data-testid={`lp-testimonial-photo-${t.id}`} />
        : <span className="lp-testimonial-photo" aria-hidden="true" style={AVATAR}>{initials(t.name)}</span>}
      <div>
        <div className="lp-testimonial-name">{t.name}</div>
        {t.case_tag && <div className="lp-testimonial-case">{t.case_tag}</div>}
      </div>
    </figcaption>
  </figure>
);

export const ClassicTestimonials = ({ code }) => {
  const items = useBuyerTestimonials(code);
  if (!items.length) return null;
  return (
    <section className="lp-testimonials-wrap" aria-label="Client testimonials" data-testid="lp-testimonials">
      <div className="lp-section">
        <div className="lp-eyebrow lp-eyebrow-inverse">Real stories</div>
        <h2 className="lp-section-title lp-section-title-inverse">People who&apos;ve been in your shoes</h2>
        <div className="lp-testimonials">
          {items.map((t) => <ClassicCard key={t.id} t={t} />)}
        </div>
        <div className="lp-testimonial-disclaimer">{TESTIMONIAL_DISCLAIMER}</div>
      </div>
    </section>
  );
};

const CARD = { background: "#fff", color: "#0f172a", border: "1px solid rgba(15,23,42,0.12)", borderRadius: 12, padding: 14, margin: 0 };

export const ThankYouTestimonials = ({ code, firm, title, wide = false }) => {
  const items = useBuyerTestimonials(code);
  if (!items.length) return null;
  return (
    <section data-testid="lp-thankyou-testimonials" style={wide ? { width: "100%", textAlign: "left" } : { maxWidth: 720, width: "100%", margin: "28px auto 0", textAlign: "left" }}>
      <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 10, opacity: 0.8 }}>
        {title || `What ${firm ? `${firm} clients` : "clients"} say`}
      </div>
      <div className={`grid grid-cols-1 gap-3 ${items.length > 1 ? "sm:grid-cols-2" : ""}`}>
        {items.slice(0, 4).map((t) => (
          <figure key={t.id} style={CARD} data-testid={`lp-thankyou-testimonial-${t.id}`}>
            <div style={{ color: "#f59e0b" }} aria-label={`${t.stars} star review`}>{"★".repeat(t.stars)}</div>
            <blockquote style={{ margin: "6px 0 0", lineHeight: 1.55, fontSize: 14 }}>&ldquo;{t.quote}&rdquo;</blockquote>
            <figcaption style={{ marginTop: 8, fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}>
              {testimonialPhoto(t) && <img src={testimonialPhoto(t)} alt="" style={{ width: 32, height: 32, borderRadius: 999, objectFit: "cover" }} />}
              <span>{t.name}{t.case_tag && <span style={{ fontWeight: 400, color: "#64748b" }}> · {t.case_tag}</span>}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <div style={{ fontSize: 10.5, opacity: 0.7, marginTop: 8 }}>{TESTIMONIAL_DISCLAIMER}</div>
    </section>
  );
};
